import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';

import { ToggleSwitch } from '@C/FormElements';
import services from '@C/Utils/data';
import { DateFilter } from '@C/Utils';
import { authHeader } from '@H';

import './styles.scoped.scss';

class DashboardFuelPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: new Date(),
      fuelList: [],
      edit: false,
      updated: false,
      date: this.props.date ? this.props.date : dayjs().format('YYYY-MM-DD'),
      disabled: this.props.disabled ? this.props.disabled : false,
      duty_price_change: this.props.duty_price_change || false,
      duty_price_change_done: false,
      enable_duty_price_change: false,
      isSubmitting: false,
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div className="input-error">{message}</div>,
    });
  }

  componentDidMount() {
    this.getFuelPrice();
  }

  getFuelPrice = () => {
    services
      .getFuelWithPrice(this.state.date)
      .then((response) => {
        this.setState({
          fuelList: response.data.data.fuel_prices,
          updated: response.data.data.is_all_product_prices_updated,
          duty_price_change_done:
            response.data.data.fuel_prices[0].is_price_updated_today,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleDutyPriceChange = () => {
    this.setState({
      enable_duty_price_change: !this.state.enable_duty_price_change,
    });
  };

  handleChange = (e, i) => {
    const fuelList = [...this.state.fuelList];
    fuelList[i][e.target.name] = e.target.value;
    this.setState({ fuelList: fuelList });
  };

  handleCopy = (event) => {
    event.preventDefault();
    let fuelList = [...this.state.fuelList];
    fuelList = fuelList.map((o) =>
      Object.assign(o, { price: o.previous_price }),
    );
    this.setState({ fuelList: fuelList });
  };
  handleCancel = () => {
    this.setState({ edit: !this.state.edit });
  };

  updatePrice = (e, usePreviousPrice = false) => {
    e.preventDefault();

    if (!this.state.edit && !usePreviousPrice) {
      this.setState({ edit: !this.state.edit });
      return;
    }

    if (!usePreviousPrice && !this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }

    const shouldPost =
      !this.state.updated ||
      this.state.duty_price_change ||
      this.state.enable_duty_price_change;

    const tmp = this.state.fuelList.map((item) => {
      return {
        product_uuid: item.product_uuid,
        price: parseFloat(usePreviousPrice ? item.previous_price : item.price),
        datetime_stamp: this.state.date,
      };
    });

    this.setState({ isSubmitting: true });
    const formData = {
      product_list: shouldPost ? tmp : this.state.fuelList,
      is_duty_price_change: this.state.enable_duty_price_change,
    };
    const headers = authHeader(1);
    const apiCall = shouldPost
      ? axios.post(`${process.env.API_URL}/bunk/fuel-prices/`, formData, {
          headers,
        })
      : axios.put(`${process.env.API_URL}/bunk/fuel-prices/`, formData, {
          headers,
        });

    apiCall
      .then((response) => {
        const message = shouldPost
          ? 'Price updated successfully'
          : response.data.message;

        toast.success(
          message,
          shouldPost
            ? {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
              }
            : undefined,
        );

        this.getFuelPrice();
        if (this.props.onRequestClose) {
          this.props.onRequestClose();
        }
        this.setState({
          edit: false,
          updated: true,
          isSubmitting: false,
        });
      })
      .catch((e) => {
        toast.error(
          usePreviousPrice
            ? 'Error updating to previous price'
            : 'Error updating price',
        );
        console.log(e);
        this.setState({ isSubmitting: false });
      });
  };

  handleDate = (e) => {
    this.setState({ date: e.target.value }, function () {
      this.getFuelPrice();
    });
  };

  render() {
    const { fuelList } = this.state;

    return (
      <>
        <section className="widget form-table">
          <header>
            <h3>Fuel Price</h3>
          </header>
          <main>
            {!this.state.updated && (
              <div className="notification-alert notification-alert__error">
                Fuel price not updated for the selected date
              </div>
            )}

            {this.state.duty_price_change_done && (
              <div className="notification-alert notification-alert__success">
                Duty price change done for the selected date.
              </div>
            )}

            <form onSubmit={this.onUpdate}>
              <div className="form-header">
                <div className="input-wrapper no-margin">
                  <DateFilter
                    className="cstm-date-input"
                    value={this.state.date}
                    onChange={this.handleDate}
                    disabled={this.state.disabled}
                  />
                </div>
                {(() => {
                  if (this.state.edit) {
                    return (
                      <>
                        <button
                          className="btn-with-icon btn-with-icon__copy white-btn"
                          type="button"
                          onClick={() => this.handleCopy(event)}
                        >
                          Copy price
                        </button>
                        <button
                          className="btn-with-icon btn-with-icon__cancel red-btn"
                          onClick={() => this.handleCancel()}
                        >
                          Cancel
                        </button>
                        <div className="input-wrapper  toggle-element">
                          <span className="label"> Is duty price change:</span>
                          <ToggleSwitch
                            did={0}
                            id="partialP"
                            name="partialP"
                            checked={this.state.enable_duty_price_change}
                            onChange={this.toggleDutyPriceChange}
                            disabled={!this.state.updated}
                          />
                        </div>
                      </>
                    );
                  }
                })()}
                <button
                  type={this.state.edit ? 'button' : 'submit'}
                  className={`btn-with-icon  ${
                    this.state.edit
                      ? 'btn-with-icon__save green-btn'
                      : 'btn-with-icon__edit white-btn'
                  }`}
                  disabled={this.state.isSubmitting}
                  onClick={(event) => this.updatePrice(event)}
                >
                  {this.state.edit ? 'Update price' : 'Edit price'}
                </button>
                {!this.state.edit && (
                  <button
                    type="button"
                    className="btn-with-icon btn-with-icon__save green-btn"
                    disabled={this.state.isSubmitting}
                    onClick={(event) => this.updatePrice(event, true)}
                  >
                    Update to previous price
                  </button>
                )}
              </div>
              <div className="form-content">
                <table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Previous price</th>
                      <th>Current price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fuelList.map((item, i) => (
                      <tr key={i}>
                        <td className="item-title">{item.product_name}</td>
                        <td className="item-rate-prev">
                          {item.previous_price}
                        </td>
                        <td className="item-rate">
                          <div className="input-wrapper">
                            {this.validator.message(
                              `price-${i}`,
                              item.price,
                              'numeric|min:0.1,num',
                            )}
                            <input
                              type="text"
                              disabled={!this.state.edit}
                              value={item.price}
                              name="price"
                              onChange={(event) => this.handleChange(event, i)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </main>
        </section>
      </>
    );
  }
}

export { DashboardFuelPrice };
